import { render } from "./OrganizationAdminCard.vue?vue&type=template&id=685328aa&scoped=true"
import script from "./OrganizationAdminCard.vue?vue&type=script&lang=js"
export * from "./OrganizationAdminCard.vue?vue&type=script&lang=js"

import "./OrganizationAdminCard.vue?vue&type=style&index=0&id=685328aa&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685328aa"]])

export default __exports__